<template>
  <v-layer ref="layer" :config="config">
    <v-image :config="imgWidget" />
    <v-image :config="imgSloganTitle" />
    <v-image :config="imgPictureBg" />
    <v-image :config="imgPicture" />
    <v-image :config="imgSloganSimple" />
    <v-image :config="imageLuckyTips" />
    <v-image :config="imageText" />
    <v-image :config="imageQr" />
    <v-text :config="textConfig" />
  </v-layer>
</template>

<script>
import ImageWidget from '@/assets/event-ic-widget-02.png'
import ImageSloganTitle from '@/assets/event-ic-bg-slogan-title.png'
import ImageSloganSimple from '@/assets/event-ic-slogan-simple.png'
import ImageLuckyTips from '@/assets/event-ic-lucky-tips.png'
import ImageQrCode from '@/assets/event-ic-qrcode.png'

import { help } from './help'

export default {
  mixins: [help],
  props: {
    picture: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      config: {
        visible: false
      },
      imgWidget: {
        image: null,
        x: this.transformWH(0),
        y: this.transformWH(236)
      },
      imgSloganTitle: {
        image: null,
        x: this.transformWH(50),
        y: this.transformWH(330),
        scaleX: 0.8,
        scaleY: 0.8,
        rotation: -6
      },
      imgSloganSimple: {
        image: null,
        x: this.transformWH(430),
        y: this.transformWH(850)
      },
      imgPictureBg: {
        x: this.transformWH(30),
        y: this.transformWH(480),
        width: this.transformWH(597),
        height: this.transformWH(384),
        fill: 'rgb(120,120,120)',
        rotation: -6
      },
      imgPicture: {
        image: null,
        x: this.transformWH(30),
        y: this.transformWH(480),
        width: this.transformWH(597),
        height: this.transformWH(384),
        rotation: -6
      },
      imageLuckyTips: {
        image: null,
        x: this.transformWH(80),
        y: this.transformWH(930)
      },
      imageText: {
        image: null,
        x: this.transformWH(32),
        y: this.transformWH(1062),
        scaleX: 1.2,
        scaleY: 1.2
      },
      imageQr: {
        image: null,
        x: this.transformWH(556),
        y: this.transformWH(1062),
        width: this.transformWH(160),
        height: this.transformWH(160)
      },
      textConfig: {
        text: '长按保存图，扫码有好运',
        fill: '#fff',
        fontSize: this.transformWH(20),
        x: this.transformWH(515),
        y: this.transformWH(1232)
      }
    }
  },
  watch: {
    picture(src) {
      if (!src) {
        return
      }
      this.getImage(src).then(img => {
        this.imgPicture.image = img
      })
    },
    text(src) {
      if (!src) {
        return
      }
      this.placeImage(src, 'imageText')
    }
  },
  async mounted() {
    await this.init()
  },
  methods: {
    async init() {
      try {
        await this.placeImage(ImageWidget, 'imgWidget')
        await this.placeImage(ImageSloganTitle, 'imgSloganTitle')
        await this.placeImage(ImageSloganSimple, 'imgSloganSimple')
        await this.placeImage(ImageLuckyTips, 'imageLuckyTips')
        await this.placeImage(ImageQrCode, 'imageQr', false)
      } catch (error) {
        console.error(error)
      }
    },
    async startAnimation() {
    },
    async hide() {
      this.config.visible = false
    },
    async show() {
      this.config.visible = true
    },
    async getFileBtnPosition() {
      return this.$refs['file-select'].getNode().attrs
    }
  }
}
</script>
